import React from 'react';
import { Typography } from '@material-ui/core';
import classNames from 'classnames';

import { News } from '../../../lib/models/news';
import { getLimitedText } from '../../../lib/util/DataHelpers';

import { useIsMobile } from '../../../hooks';
import { RssItem } from '../../../services/CapitalRSS/CapitalRSS.types';

import styles from './NewsCard.module.scss';

type Props = {
  item: News | RssItem;
  isExtended?: boolean;
};

const NewsCard = ({ item, isExtended }: Props): JSX.Element => {
  const { headline, source, dateTime, dateTimeText, image, url } = item;
  const isMobile = useIsMobile();

  return (
    <a href={url} target="_blank" rel="noopener noreferrer">
      <div
        className={styles.card}
        style={isMobile ? { width: `${window.innerWidth - 64}px` } : {}}
      >
        <div className={styles.wrapperImg}>
          <div className={classNames(styles.img, { [styles.imgExtended]: isExtended && !isMobile })} style={{ backgroundImage: `url(${image})` }} />
        </div>
        <div className={styles.dataWrapper}>
          <p className={styles.meta}>
            {source}
            <span>{dateTimeText}</span>
          </p>
          <Typography className={isMobile ? styles.titleMobile : styles.title}>
            {getLimitedText(headline, isExtended && !isMobile ? 160 : 55)}
          </Typography>
        </div>
      </div>
    </a>
  );
};

export default NewsCard;
